var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LinearProgress } from './Linear';
import { CircleProgress } from './Circle';
import { Animated } from './Animated';
export var Progress = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.shape, shape = _c === void 0 ? 'linear' : _c, _d = _a.cycled, cycled = _d === void 0 ? false : _d, _e = _a.strokeWidth, strokeWidth = _e === void 0 ? 4 : _e, _f = _a.size, size = _f === void 0 ? 44 : _f, _g = _a.type, type = _g === void 0 ? 'container' : _g, props = __rest(_a, ["value", "shape", "cycled", "strokeWidth", "size", "type"]);
    if (shape === 'linear') {
        return (React.createElement(LinearProgress, __assign({ value: value, type: type, cycled: cycled, strokeWidth: strokeWidth }, props)));
    }
    if (shape === 'animated') {
        return React.createElement(Animated, __assign({}, props));
    }
    // В случае передачи 0 в круговой прогресс.
    if (!size) {
        return null;
    }
    return (React.createElement(CircleProgress, __assign({ value: value, cycled: cycled, strokeWidth: strokeWidth, size: size }, props)));
};
